import { isApiError } from './isApiError';

export type ParsedApiError = {
  code: string;
  message: string;
  status: number;
  details?: unknown;
  traceId?: string;
};

export const parseApiError = (errorData: unknown, statusCode = 500): ParsedApiError => {
  if (!errorData || typeof errorData !== 'object') {
    return { code: 'UNKNOWN', message: `HTTP ${statusCode}`, status: statusCode };
  }

  const data = errorData as Record<string, unknown>;

  if (isApiError(data)) {
    return {
      code: data.code,
      message: data.message,
      status: data.status,
      details: data.details,
      traceId: data.traceId,
    };
  }

  if (typeof data.error === 'string') {
    return { code: 'LEGACY_ERROR', message: data.error, status: statusCode };
  }

  if (data.status === 'error' && typeof data.message === 'string') {
    return { code: 'LEGACY_ERROR', message: data.message, status: statusCode };
  }

  if (typeof (data.error as Record<string, unknown>)?.message === 'string') {
    return { code: 'LEGACY_ERROR', message: (data.error as { message: string }).message, status: statusCode };
  }

  if (typeof data.message === 'string') {
    return { code: 'LEGACY_ERROR', message: data.message, status: statusCode };
  }

  return { code: 'UNKNOWN', message: `HTTP ${statusCode}`, status: statusCode };
};
